module.exports = __webpack_public_path__ + "img/COMBO RADIO 2 GREEN.7a11afc.svg";